<template>
  <div v-if="error">
    <div class="container text-center" style="margin-top: 20px">
      {{ error }}
    </div>
  </div>
  <div v-else-if="belowRequiredResponseCount">
    <div class="container text-center" style="margin-top: 20px">
      <h1>More colleagues need to finish their strength mapping to view this report.</h1>
    </div>
  </div>
  <div v-else-if="!error && !belowRequiredResponseCount" class="text-big custom-theme">
    <div v-if="isLoaded">
      <div class="container maxWidth-sm">
        <div style="height: 40px"></div>
        <div class="title-container">
          <div class="title-text">
            <div class="report-title" v-html="titleHtml" data-test="title"></div>
            <hr class="hr-magazine hr-magazine-thick hr-magazine-left hr-magazine-short" />
            <p class="report-subtitle" v-html="subtitleHtml" data-test="subtitle"></p>
            <hr class="hr-magazine hr-magazine-thick hr-magazine-left hr-magazine-short" />
          </div>
          <ShareButton
            v-if="canShare"
            :reportEntityId="reportEntityId"
            :reportType="sharingReportType"
            urlDescription=""
          />
        </div>
      </div>
      <CmsBody :cmsPage="doc" :completedActivityIds="[]"></CmsBody>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, onBeforeMount, provide, ref } from "vue";
import cms from "../services/cms/cms";
import { CustomSoloReportApiModel } from "../api-models";
import { CmsDocumentTypes } from "../services/cms/cms-type-configuration";
import { CmsCustomStrengthMapping } from "../services/cms/cms-type-definitions";
import CmsBody from "../components/cms/cms-body.vue";
import ShareButton from "../components/share-button.vue";
import { csContext } from "../services/cs-context";

const props = defineProps<{
  model: CustomSoloReportApiModel;
}>();

const doc = ref<CmsCustomStrengthMapping | null>(null);

const isLoaded = ref(false);

const belowRequiredResponseCount = ref(false);

const error = ref("");

const label = "dynamic-render";

const report = computed(() => props.model);
provide("report", report);

const values = ref<string[]>([]);
provide("values", values);

const titleHtml = computed(() => cms.asHtml(doc.value?.data?.report_title));

const subtitleHtml = computed(() => report.value.reportOwnerName);

const canShare = computed(() => !!props.model && csContext?.user?.id === props.model.reportOwnerId);

const sharingReportType = "CustomFrameworkSoloReport";

const reportEntityId = computed(() => {
  return `${csContext.user.id}|${props.model.customStatistics?.id.toLowerCase()}`;
});

const hideViewpointsSection = (): CmsCustomStrengthMapping | null => {
  if (doc.value !== null && !props.model.customStatistics.viewpointsItems) {
    doc.value.data.body = doc.value.data.body.filter((slice) => slice.slice_label !== label);
  }
  return doc.value;
};

onBeforeMount(async () => {
  if (props.model == null) {
    error.value =
      "There was a problem getting your report. Please try refreshing the page, and if that doesn't work, you can contact us at support@gyreteams.com";
    return;
  }

  if (!props.model.customStatistics?.soloItems) {
    belowRequiredResponseCount.value = true;
    return;
  }

  doc.value = await cms.getById(
    CmsDocumentTypes.CmsCustomStrengthMapping,
    props.model.userValues.metadata.id,
  );

  const reportList = doc.value.data?.body.find((slice) => slice.slice_type === "cms-report-list");
  values.value = reportList?.items.map((value) => value.report_list_text[0].text) as string[];
  doc.value = hideViewpointsSection();
  isLoaded.value = true;
});

// @Component({
//   components: { CmsBody, ShareButton, CustomSoloBarGraph, CustomViewpointsBarGraph },
// })
// export default class CustomSoloReport extends Vue {
//   @Prop() model!: CustomSoloReportApiModel;

//   doc: CmsCustomStrengthMapping | null = null;

//   isLoaded = false;

//   belowRequiredResponseCount = false;

//   error = "";

//   private label = "dynamic-render";

//   @Provide("report") report = this.model;

//   @ProvideReactive("values") values: string[] = [];

//   get titleHtml(): string {
//     return cms.asHtml(this.doc?.data?.report_title);
//   }

//   get subtitleHtml(): string {
//     return this.report.reportOwnerName;
//   }

//   get canShare(): boolean {
//     return !!this.model && csContext?.user?.id === this.model.reportOwnerId;
//   }

//   get sharingReportType(): ReportSharingTypeApiModel {
//     return "CustomFrameworkSoloReport";
//   }

//   get reportEntityId(): string {
//     return `${csContext.user.id}|${this.model.customStatistics?.id.toLowerCase()}`;
//   }

//   hideViewpointsSection(): CmsCustomStrengthMapping | null {
//     if (this.doc !== null && !this.model.customStatistics.viewpointsItems) {
//       this.doc.data.body = this.doc.data.body.filter((slice) => slice.slice_label !== this.label);
//     }
//     return this.doc;
//   }

//   async beforeMount() {
//     if (this.model == null) {
//       this.error =
//         "There was a problem getting your report. Please try refreshing the page, and if that doesn't work, you can contact us at support@gyreteams.com";
//       return;
//     }

//     if (!this.model.customStatistics?.soloItems) {
//       this.belowRequiredResponseCount = true;
//       return;
//     }

//     this.doc = await cms.getById(
//       CmsDocumentTypes.CmsCustomStrengthMapping,
//       this.model.userValues.metadata.id,
//     );

//     const reportList = this.doc.data?.body.find((slice) => slice.slice_type === "cms-report-list");
//     this.values = reportList?.items.map((value) => value.report_list_text[0].text) as string[];
//     this.doc = this.hideViewpointsSection();
//     this.isLoaded = true;
//   }
// }
</script>
<style lang="less"></style>
